import{b as o}from"./chunk-VCGHU5KR.js";import{m as t}from"./chunk-HBP5N4FR.js";t();import r from"react";import p from"classnames";var f=({color:s,"data-testid":a,className:e="dapp-dot"})=>r.createElement("span",{className:p(o.dot,s,e),"data-testid":a});export{f as a};
//# sourceMappingURL=chunk-DT37QZH6.js.map
